// Firebase app initialization. Reads config from Vite env ONLY (see
// .env.example / README.md "Security notes") — no key or config value is
// ever hardcoded here. The real values are populated in the deploy box's
// `.env` file; this bundle never sees them at build time in this repo.
//
// The app MUST still build/preview cleanly with the VITE_FIREBASE_* vars
// unset (e.g. an offline preview). When that's the case we skip
// `initializeApp` entirely and export `auth: null` — every consumer
// (AuthContext, apiClient's getIdToken) checks `isFirebaseConfigured`
// before touching `auth`, so nothing crashes.

import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId
);

let app = null;
let auth = null;

if (isFirebaseConfigured) {
  app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
  auth = getAuth(app);
} else if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.warn(
    '[firebase] VITE_FIREBASE_* env vars are unset — sign-in/sign-up/reset ' +
      'will render a "not configured" state instead of a live form. See ' +
      '.env.example and README.md "Security notes".'
  );
}

export { app, auth };
